import { completeResetPassword } from '../../services/authentication';
import { unauthenticatedPaths } from '../../router/constants/route-paths';
import { useNavigate, useParams } from 'react-router-dom';
import { FormWithPasswordMeter } from './PasswordForms/FormWithPasswordMeter';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';

const ResetPassword = () => {
    const navigate = useNavigate();

    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.authentication
                .resetPassword
    );

    const { email, code } = useParams();

    if (!code || !email) {
        navigate(unauthenticatedPaths.signIn);
        return <></>;
    }

    return (
        <FormWithPasswordMeter
            buttonText={localization.resetBtn}
            onSubmit={async (password: string) =>
                await completeResetPassword(email as string, code, password)
            }
        />
    );
};

export default ResetPassword;
